import * as React from "react";
import { CobrowsingContainer } from "./CobrowsingContainer";
import env from "../env";

interface MainContentContainerProps {
  children: React.ReactNode;
  coBrowsingEnabled: boolean;
}

export const MainContentContainer = ({ children, coBrowsingEnabled } : MainContentContainerProps) => (
  <>
    <main role="main" id="main-content" className="container" data-version={env?.BUILD_PCKG_VERSION ?? ""}>
      {children}
    </main>

    {coBrowsingEnabled && <CobrowsingContainer />}

    <div id="breakpoint-sizer" aria-hidden="true">
      <div className="d-block d-sm-none d-md-none d-lg-none d-xl-none" data-size="xs" />
      <div className="d-none d-sm-block d-md-none d-lg-none d-xl-none" data-size="sm" />
      <div className="d-none d-sm-none d-md-block d-lg-none d-xl-none" data-size="md" />
      <div className="d-none d-sm-none d-md-none d-lg-block d-xl-none" data-size="lg" />
      <div className="d-none d-sm-none d-md-none d-lg-none d-xl-block" data-size="xl" />
    </div>
  </>
);
